import { useEffect } from 'react';
import { AccountId, PermissionId, ProjectId } from 'api/models';
import { ProjectChannel, pushes } from 'api/pushes';
import { useAccount } from './use-account';
import { useLatest } from './use-latest';
import { useUser } from './use-user';
export const useProjectWSUpdates = (projectId, handler, [action, objectType])=>{
    var _projects_projectId;
    const { permissions: { projects } } = useUser();
    const { accountId } = useAccount();
    const permissionId = (_projects_projectId = projects[projectId]) === null || _projects_projectId === void 0 ? void 0 : _projects_projectId.permissionSet.permissionSetId;
    const latestHandler = useLatest(handler);
    useEffect(()=>{
        let subscription;
        if (permissionId) {
            const channel = ProjectChannel(AccountId(accountId), PermissionId(permissionId), ProjectId(projectId));
            // Self-echo (own `hopId`) is NOT filtered here. This hook is shared by
            // every ProjectChannel subscriber — tasks, conversations, doc
            // discussions, project/phase/member details, etc. Consumers with an
            // optimistic local representation of their own change (e.g. task
            // collection sync) must skip their own echo themselves — see
            // `useProjectTaskWebsocket` — since consumers with NO optimistic
            // representation (e.g. conversations refetching a new audit-log
            // comment) genuinely need their own echo to update.
            subscription = pushes(channel, [
                action,
                objectType
            ]).subscribe(latestHandler);
        }
        return ()=>subscription === null || subscription === void 0 ? void 0 : subscription.unsubscribe();
    }, [
        accountId,
        action,
        latestHandler,
        objectType,
        permissionId,
        projectId
    ]);
};
